/**
 * Config enum translations - English
 * Includes: merchantWorkbench config, assetTypes config enum labels
 */
export default {
  config: {
    // ==================== assetTypes config ====================
    assetType: {
      shop: 'Shop',
      advertising: 'Advertising',
      sharedSpace: 'Shared Space',
      warehouse: 'Warehouse',
      parking: 'Parking',
      officeSpace: 'Office Space',
    },
    assetStatus: {
      available: 'Available',
      rented: 'Rented',
      maintenance: 'Maintenance',
      reserved: 'Reserved',
      split: 'Split',
      merged: 'Merged',
    },
    advertisingType: {
      indoor: 'Indoor',
      outdoor: 'Outdoor',
      elevator: 'Elevator',
      commonArea: 'Common Area',
    },
    displayType: {
      static: 'Static',
      digital: 'Digital',
      led: 'LED Screen',
    },
    sharedSpaceType: {
      activity: 'Activity Area',
      exhibition: 'Exhibition Area',
      corridor: 'Corridor',
      other: 'Other',
    },
    storageType: {
      normal: 'Normal Temp',
      refrigerated: 'Refrigerated',
      frozen: 'Frozen',
    },
    parkingType: {
      normal: 'Standard',
      disabled: 'Accessible',
      vip: 'VIP',
      electric: 'EV Charging',
    },
    officeSpaceType: {
      standard: 'Standard',
      openPlan: 'Open Plan',
      suite: 'Suite',
    },
    shopType: {
      retail: 'Retail',
      food: 'Food & Beverage',
      entertainment: 'Entertainment',
      service: 'Service',
    },
    buildingType: {
      mall: 'Mall',
      office: 'Office',
      residential: 'Residential',
      hotel: 'Hotel',
      other: 'Other',
    },
    businessType: {
      retail: 'Retail',
      food: 'Food & Beverage',
      entertainment: 'Entertainment',
      service: 'Service',
      mixed: 'Mixed',
    },

    // ==================== merchantWorkbench layer config ====================
    layer: {
      basic: 'Basic Info',
      analytics: 'Analytics',
      progress: 'Leasing Progress',
      operation: 'Operation Status',
    },
    layerDescription: {
      basic: 'Show basic asset status (Rented / Vacant / Reserved / Maintenance)',
      analytics: 'Show leasing statistics charts (signing rate, business type distribution, lease rate, etc.)',
      progress: 'Show leasing execution progress (independent of unit status, tracking leasing workflow)',
      operation: 'Show tenant operation data (reserved feature)',
    },
    basicStatus: {
      rented: 'Rented',
      rentedDesc: 'Asset is currently rented',
      available: 'Vacant',
      availableDesc: 'Asset is currently vacant and available',
      reserved: 'Reserved',
      reservedDesc: 'Asset is reserved',
      maintenance: 'Maintenance',
      maintenanceDesc: 'Asset is under maintenance',
    },
    planningType: {
      retail: 'Retail',
      retailDesc: 'Retail business type',
      food: 'F&B',
      foodDesc: 'Food & Beverage business type',
      entertainment: 'Entertainment',
      entertainmentDesc: 'Entertainment business type',
      service: 'Service',
      serviceDesc: 'Service business type',
      none: 'Unplanned',
      noneDesc: 'Business type not yet planned',
    },
    progressStatus: {
      entered: 'Opened',
      enteredDesc: 'Tenant has opened for business (leasing completed)',
      renovating: 'Renovating',
      renovatingDesc: 'Tenant is renovating (contract signed, renovation in progress)',
      signed: 'Signed',
      signedDesc: 'Contract signed, pending tenant move-in',
      active: 'Intent Active',
      activeDesc: 'Leasing intent reached, pending contract signing',
      negotiating: 'Negotiating',
      negotiatingDesc: 'Negotiation records exist, in contact with tenant',
      reserved: 'Reserved',
      reservedDesc: 'Asset is reserved, not available for leasing',
      maintenance: 'Maintenance',
      maintenanceDesc: 'Asset under maintenance, not available for leasing',
      vacant: 'Available',
      vacantDesc: 'Vacant, no leasing activity records',
    },
    operationStatus: {
      reserved: 'Reserved',
      reservedDesc: 'Feature not yet implemented',
    },

    // ==================== Lifecycle stages ====================
    lifecycle: {
      businessPlan: 'Simulated Placement',
      businessPlanDesc: 'Simulated brand placement',
      policySetting: 'Policy Setting',
      policySettingDesc: 'Set leasing policy for shop',
      negotiation: 'Negotiation',
      negotiationDesc: 'Merchant negotiation and communication',
      intention: 'Intention',
      intentionDesc: 'Confirm leasing intention',
      formalPlacement: 'Formal Placement',
      formalPlacementDesc: 'Formal placement after intention confirmation',
      contractSigned: 'Contract Signed',
      contractSignedDesc: 'Formal contract signing completed',
    },
    lifecycleAction: {
      setBusinessType: 'Set Business Type',
      setPolicy: 'Set Policy',
      addNegotiation: 'Add Negotiation',
      createIntention: 'Create Intent',
      createContract: 'Create Contract',
      createPlacement: 'Create Placement',
    },

    // ==================== Context menu ====================
    contextMenu: {
      setBusinessType: 'Set Business Type',
      setPolicy: 'Set Leasing Policy',
      addNegotiation: 'Add Negotiation Record',
      createIntention: 'Create Leasing Intent',
      createContract: 'Create Contract',
      cancelIntention: 'Cancel Intent',
      viewContract: 'View Contract',
      merchantEnter: 'Tenant Move-in',
      merchantExit: 'Tenant Move-out',
      viewRenovation: 'Renovation Mgmt',
      viewPlacement: 'Simulate Placement',
      viewBusinessPlan: 'Business Planning',
    },

    approvalPendingTip: 'Approval in progress, please wait for the result',
  },
}
